import React, { useState } from "react";
import "./McaCourse.css";
import { Helmet } from "react-helmet-async";

// ✅ All FontAwesome icons in one line
import {
  FaStar,
  FaClock,
  FaLaptop,
  FaUserCheck,
  FaBookOpen,
  FaHandsHelping,
  FaUniversity,
  FaGraduationCap,
  FaBook,
  FaLayerGroup,
  FaChartLine,
  FaHandshake,
  FaUsers,
  FaPlus,
  FaMinus,
  FaSnowflake,
  FaUser,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
} from "react-icons/fa";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Form,
} from "react-bootstrap";

import Slider from "react-slick";
import Admission from "../../components/Admission";
import Partner from "../../components/Partner";

export default function McaCourse() {
  const careers = [
    {
      icon: "💻",
      title: "Software Developer",
    },
    {
      icon: "🌐",
      title: "Web Developer",
    },
    {
      icon: "📊",
      title: "Data Analyst",
    },
    {
      icon: "🖥️",
      title: "System Analyst",
    },
    {
      icon: "🗄️",
      title: "Database Administrator",
    },
    {
      icon: "☁️",
      title: "Cloud Engineer",
    },
    {
      icon: "🔐",
      title: "Cybersecurity Analyst",
    },
    {
      icon: "📂",
      title: "IT Project Manager",
    },
  ];

  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Establishing goals & blueprints for the new website",
      icon: "🔍",
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Defining information architecture & content plan",
      icon: "📝",
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Designing the form & function of the website",
      icon: "🎨",
    },
  ];

  const highlights = [
    {
      icon: "⏰",
      title: "Course Duration",
      description:
        "2 years (4 semesters) — designed for efficient learning while balancing work or other commitments.",
    },
    {
      icon: "📚",
      title: "Learning Mode",
      description:
        "Distance / Online — study from anywhere with access to online classes, study material, and recorded lectures.",
    },
    {
      icon: "🔍",
      title: "Eligibility",
      description:
        "A bachelor's degree (preferably BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation.",
    },
    {
      icon: "🏛️",
      title: "University Recognition",
      description:
        "Courses offered are from UGC and AICTE-approved universities, ensuring your degree is valid and recognized.",
    },
    {
      icon: "📖",
      title: "Curriculum",
      description:
        "Covers core programming, software engineering, DBMS, networking, cloud computing, and more.",
    },
    {
      icon: "🎧",
      title: "Support & Flexibility",
      description:
        "Study on your schedule with weekend sessions, recorded classes, student support, and online doubt-solving.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const data = [
    { icon: <FaChartLine />, number: "100%", label: "Success Rate" },
    { icon: <FaHandshake />, number: "35+", label: "Years Of Service" },
    { icon: <FaUsers />, number: "8k+", label: "Students" },
    { icon: <FaBook />, number: "10+", label: "Courses" },
  ];

  const plans = [
    {
      id: "01",
      color: "#00c6ff",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "02",
      color: "#2ecc71",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "03",
      color: "#f1c40f",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "04",
      color: "#e67e22",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "05",
      color: "#9b59b6",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "06",
      color: "#2980b9",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
  ];

  const blogs = [
    {
      title: "Writing Class",
      image: "https://via.placeholder.com/400x250?text=Writing+Class",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Crafts Activities",
      image: "https://via.placeholder.com/400x250?text=Crafts+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Math Activities",
      image: "https://via.placeholder.com/400x250?text=Math+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
  ];

  const faqData = [
    {
      question: "What is a Distance MCA program?",
      answer:
        "A Distance MCA is a postgraduate computer applications degree offered online or through correspondence, focusing on software development, programming, and IT management.",
    },
    {
      question: "Is a Distance MCA recognized and valid for jobs?",
      answer:
        "Yes, a Distance MCA from a UGC or AICTE-approved university is recognized by employers and is valid for both private and government jobs as well as higher studies.",
    },
    {
      question: "What are the eligibility criteria for MCA distance education?",
      answer:
        "Applicants typically need a bachelor’s degree in Computer Science, IT, or a related field. Some universities also accept graduates with Mathematics in 10+2 or at the undergraduate level.",
    },
    {
      question: "How long does it take to complete a Distance MCA?",
      answer:
        "Most programs take 2 to 3 years to complete, with some universities offering flexible schedules or the option to extend the duration if needed.",
    },
    {
      question: "Can I work while pursuing a Distance MCA?",
      answer:
        "Yes. Distance MCA programs are designed for working professionals, allowing you to study online, access digital resources, and submit assignments without interrupting your job.",
    },
    {
      question: "What career opportunities are available after a Distance MCA?",
      answer:
        "Graduates can work as Software Developers, System Analysts, Data Scientists, Database Administrators, Web Developers, or move into IT project management and research roles.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const features = [
    {
      icon: <FaSnowflake />,
      title: "Study While You Work",
      details:
        "Pursue an MCA distance education in Bangalore without leaving your job. The flexible format lets you balance work, study, and personal commitments seamlessly.",
    },
    {
      icon: <FaUser />,
      title: "Access Anytime, Anywhere",
      details:
        " Learn from home or any location. Distance MCA colleges in Bangalore provide all resources online, eliminating the need for physical attendance.",
    },
    {
      icon: <FaDollarSign />,
      title: "Lower Cost, Same Degree",
      details:
        "Distance MCA programs are more affordable than traditional courses, yet the degree from best MCA distance learning colleges in Bangalore is equally recognized.",
    },
    {
      icon: <FaBuilding />,
      title: "UGC/AICTE Approved Programs",
      details:
        "Earn a credible UGC approved MCA distance education degree, accepted nationally and internationally for jobs, promotions, and higher studies.",
    },
    {
      icon: <FaTruck />,
      title: "Career-Aligned Curriculum",
      details:
        "Our programs focus on real-world skills, covering software development, cloud computing, database management, and AI to prepare students for high-demand IT roles.",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Self-Paced Learning with Expert Support",
      details:
        "Learn at your own pace while receiving guidance, mentorship, and doubt-solving sessions from faculty at best online MCA colleges.",
    },
  ];

  const highlightsData = [
    {
      icon: <FaClock size={36} className="text-primary mb-3" />,
      title: "Course Duration",
      description:
        "The MCA program spans 2 years (4 semesters), designed for efficient learning while balancing work or personal commitments, providing a flexible path to earn a UGC-approved MCA distance education degree.",
    },
    {
      icon: <FaLaptop size={36} className="text-success mb-3" />,
      title: "Learning Mode",
      description:
        "Study through online MCA courses in Bangalore at your convenience. Access recorded lectures, digital study materials, and interactive learning anytime, making MCA distance education in Bangalore highly flexible for all students.",
    },
    {
      icon: <FaUserCheck size={36} className="text-warning mb-3" />,
      title: "Eligibility",
      description:
        "Applicants should have a bachelor’s degree (BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation. Eligibility ensures you can enroll in distance MCA colleges in Bangalore without hurdles.",
    },
    {
      icon: <FaUniversity size={36} className="text-info mb-3" />,
      title: "University Recognition",
      description:
        "Programs are UGC approved MCA online, recognized nationally for jobs, promotions, and higher studies, offered by the best online MCA colleges in Bangalore.",
    },
    {
      icon: <FaBookOpen size={36} className="text-danger mb-3" />,
      title: "Curriculum",
      description:
        "Covers programming, DBMS, software engineering, networking, cloud computing, AI, and cybersecurity to prepare students for careers in IT through best MCA distance learning colleges in Bangalore.",
    },
    {
      icon: <FaHandsHelping size={36} className="text-secondary mb-3" />,
      title: "Support & Flexibility",
      description:
        "Learn at your own pace with weekend sessions, online assessments, recorded lectures, and dedicated guidance from faculty, ensuring smooth learning through MCA correspondence courses in Bangalore.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          MCA Distance Education in Bangalore | UGC Approved Online MCA
        </title>
        <meta
          name="description"
          content="Pursue UGC-approved MCA distance education in Bangalore. Join the best online MCA colleges offering flexible online MCA courses and correspondence programs."
        />
      </Helmet>
      <div className="mca-course-page">
        {/* <div className="banner">
        <div className="content">
          <h1>
            Professional Web <span className="highlight">Developing</span>{" "}
            Learning Course
          </h1>
          <p>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
            commodo ligula eget dolor. Aenean massa. Cum
          </p>
          <p className="hours">All Class 90 Hours</p>
          <div className="buttons">
            <button className="start-btn">Start Now</button>
            <span className="contact">+00 00 00 00 000</span>
            <span className="website">www.yourwebsite.com</span>
          </div>
        </div>
        <div className="image-container">
          <img
            src="https://images.unsplash.com/photo-1593642532973-d31b6557fa68"
            alt="Course"
          />
        </div>
      </div> */}

        {/* ===== MCA Course Header ===== */}
        <section className="mca-course-header py-5 text-white">
          <Container>
            <Row className="align-items-center">
              {/* MCA Course Info */}
              <Col md={7} className="mca-course-header-content">
                <span className="mca-course-badge badge bg-warning text-dark mb-3">
                  Live Classes
                </span>
                <h1 className="mca-course-title fw-bold mb-3">
                  Master of Computer Applications (MCA)
                </h1>
                <p className="mca-course-subtitle lead mb-3">
                  This MCA program is designed to build a strong foundation in
                  computer applications, programming, software development, and
                  IT management. You’ll gain advanced skills required for
                  careers in the tech industry.
                </p>
                <Button
                  variant="warning"
                  size="lg"
                  className="mca-course-enroll-btn fw-bold"
                >
                  Get admitted to the batch
                </Button>

                {/* MCA Course Rating */}
                <div className="mca-course-rating mt-3 d-flex align-items-center">
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <span className="ms-2">(4.8)</span>
                </div>
              </Col>

              {/* MCA Course Thumbnail */}
              <Col md={5} className="mca-course-header-thumbnail text-center">
                <img
                  src="/images/328733-removebg-preview.png"
                  alt="MCA Course Preview"
                  style={{ height: "400px", marginTop: "40px" }}
                />
              </Col>
            </Row>
          </Container>
        </section>

        {/* ===== MCA Course Content Section ===== */}

        <section className="py-5" style={{ backgroundColor: "#F5F5F5" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              MCA Distance Education – Advance Your Career in the IT Industry
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              The Master of Computer Applications (MCA) is a two-year
              postgraduate degree program designed for individuals who want to
              build or advance their careers in information technology and
              computer science. Through MCA distance education, students can
              earn a recognized degree from UGC-approved MCA distance education
              universities without attending regular classroom sessions. This
              flexible learning mode is ideal for working professionals,
              graduates from non-IT backgrounds, and anyone looking to upskill
              for better job opportunities. An MCA distance education in
              Bangalore program covers key areas such as programming languages,
              database management systems, software engineering, computer
              networks, data analytics, cloud computing, and AI. The curriculum
              aligns with industry trends and equips students with practical
              skills for roles like software developer, IT consultant, systems
              analyst, or data engineer. The biggest advantage of pursuing an
              online MCA course in Bangalore is flexibility. Students can study
              at their own pace, access recorded lectures, participate in online
              assessments, and interact with mentors virtually. Cost-effective
              and highly accessible, distance MCA colleges in Bangalore provide
              quality education without compromising recognition. Choosing
              courses from best online MCA colleges or MCA correspondence
              courses in Bangalore ensures your degree is valid for government
              jobs, corporate roles, and higher studies. Whether you want to
              develop applications, manage IT systems, or lead technical teams,
              an MCA degree opens doors to diverse tech-focused careers.
            </p>
          </Container>
        </section>

        <section
          style={{ background: "linear-gradient(to right, #f9fafb, #eef2ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Key Highlights of MCA Distance Education
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                Making quality education accessible, flexible, and
                career-focused for learners across India.
              </p>
            </div>

            {/* Highlights Grid */}
            <Row className="g-4">
              {highlightsData.map((highlight, index) => (
                <Col md={6} key={index}>
                  <Card className="h-100 shadow border-0 text-center">
                    <Card.Body>
                      {highlight.icon}
                      <h5 className="fw-bold">{highlight.title}</h5>
                      <p className="text-muted">{highlight.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="why-section">
          <div className="why-head">
            <h1> Why Choose MCA via Distance Education?</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img
                src="/images/whychoose.jpg"
                alt="Why Choose Bangalore Distance Education for Your MCA Distance Education"
              />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                Distance MCA programs are becoming increasingly popular for
                students and working professionals who want to advance their
                careers without disrupting their current schedules. Here’s why
                choosing an MCA through distance education is a smart move:
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Admission Process */}

        <Admission></Admission>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h1 className="text-center mb-5">Career Opportunities After MCA</h1>
            <p
              className="text-center mb-5"
              style={{ color: "#666", fontSize: "16px" }}
            >
              Earning an MCA through distance education opens up diverse career
              opportunities in the growing tech industry. With advanced
              knowledge in programming, software systems, and IT management, MCA
              graduates are highly sought after in both private and public
              sectors.
            </p>

            {/* Career Grid */}
            <Row className="text-center">
              {careers.map((career, index) => (
                <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                  <div style={{ fontSize: "48px" }}>{career.icon}</div>
                  <h6 className="fw-bold mt-3">{career.title}</h6>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Partner></Partner>

        {/* Register Now */}

        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>Take the Next Step with Our Distance MCA Program</h3>
            <p>
              Looking to upgrade your career in the IT field? Our UGC-approved
              MCA program is designed for future-ready professionals who want to
              build strong expertise in software development, programming, and
              system architecture — all from the comfort of home. Whether you’re
              a BCA graduate, a working professional, or someone passionate
              about tech, this course offers the flexibility, affordability, and
              industry-aligned curriculum you need to grow. Fill out the form to
              get expert guidance on admissions, course details, and university
              options — and begin your MCA journey with confidence.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form>
          </div>
        </div>

        {/* FAQ */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-5">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>

            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
